import React from 'react';
import { observer } from 'mobx-react';
import { MdOutlineClose } from 'react-icons/md';
import { useClientStore } from 'apps/hooks';
import { themes } from 'styles/themes/wikifactoryNew';
import { HeaderWithClose } from 'components';
import { CameraSettingPanelWidth } from 'styles/constants';
import Panel from './panel';
import { useNavCube } from '../navCube/useNavCube';

type CameraPanelProps = {
  isOpen: boolean;
  onToggle: () => void;
};

export const CameraPanel = observer(
  ({ isOpen, onToggle }: CameraPanelProps) => {
    const clientStore = useClientStore();

    const { renderMap } = useNavCube({
      mobileMode: clientStore.isMobile,
    });

    const panelStyle: React.CSSProperties = {
      left: 'unset',
      pointerEvents: 'auto',
      width: CameraSettingPanelWidth,
      background: themes.color.wfWhite,
      top: clientStore.PageHeaderHeight,
      height: '100%',
    };

    return (
      <>
        <Panel
          overlay
          dataTestId='CADPage-CameraSettings'
          position='right'
          title='Camera Settings'
          iconName='mesh'
          removeHeader
          isOpen={isOpen}
          style={panelStyle}
          className='border-wfGrey100'
        >
          <HeaderWithClose
            title='View Settings'
            customCloseIcon={
              <MdOutlineClose onClick={onToggle} className='cursor-pointer' />
            }
          />
          {/* TODO:@kejuqu fix overflow-y-scroll not effective  */}
          <div
            data-testid='CADPage-ViewSettingContent'
            className='w-full h-full overflow-scroll'
          >
            {renderMap.camera}
            {renderMap.render}
            {renderMap.orbit}
          </div>
        </Panel>
      </>
    );
  },
);
